(() => {
  const viewerUrl = document.currentScript.dataset.viewerUrl;
  const modelName = 'AWZZ_188535GBY_GlossBlack_Gloss_v3.glb';
  const escape = value => value.replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const style = document.createElement('style');
  style.textContent = `
    .awzz-photo-nav{display:none}
    @media(pointer:coarse){
      [data-awzz-gallery] iframe[data-awzz3d-source]{pointer-events:none}
      [data-awzz-gallery][data-awzz-interacting] iframe[data-awzz3d-source]{pointer-events:auto}
      [data-awzz-gallery] [aria-label^="Scroll thumbnails"]{display:none!important}
      .awzz-photo-nav{display:block;position:absolute;inset:0;z-index:5;pointer-events:none}
      .awzz-photo-nav button{pointer-events:auto;position:absolute;border:1px solid #ddd;background:rgba(255,255,255,.95);color:#222;cursor:pointer;font:13px Arial,sans-serif;min-height:44px;border-radius:4px}
      .awzz-photo-nav button[hidden]{display:none}
      .awzz-photo-prev,.awzz-photo-next{top:calc(50% - 22px);width:40px;font-size:26px!important}
      .awzz-photo-prev{left:8px}.awzz-photo-next{right:8px}
      .awzz-photo-mode{bottom:12px;left:50%;transform:translateX(-50%);padding:0 14px;white-space:nowrap}
      .awzz-photo-help{position:absolute;bottom:62px;left:50%;transform:translateX(-50%);white-space:nowrap;font:11px Arial,sans-serif;background:rgba(255,255,255,.9);padding:4px 7px;border-radius:3px}
    }`;
  document.head.append(style);
  function setupNavigation(frame) {
    const container = frame.closest('.pwzrswiper-container');
    const gallery = frame.closest('.rio-media-gallery');
    const swiper = container?.swiper;
    if (!swiper || container.querySelector('.awzz-photo-nav')) return;
    container.dataset.awzzGallery = '';
    gallery.dataset.awzzGallery = '';
    const nav = document.createElement('div');
    nav.className = 'awzz-photo-nav';
    nav.innerHTML = '<button type="button" class="awzz-photo-prev" aria-label="Previous product photo">‹</button><button type="button" class="awzz-photo-next" aria-label="Next product photo">›</button><span class="awzz-photo-help">Swipe for photos · Tap to rotate</span><button type="button" class="awzz-photo-mode">Rotate wheel</button>';
    const mode = nav.querySelector('.awzz-photo-mode');
    const help = nav.querySelector('.awzz-photo-help');
    function setMode(active) {
      container.toggleAttribute('data-awzz-interacting', active);
      mode.textContent = active ? 'Back to photos' : 'Rotate wheel';
      help.hidden = active;
      frame.contentWindow.postMessage({type:'awzz-3d-interaction',active}, location.origin);
    }
    function update() {
      const modelVisible = !!swiper.slides[swiper.activeIndex]?.querySelector('iframe[data-awzz3d-source]');
      setMode(false);
      mode.hidden = !modelVisible;
      help.hidden = !modelVisible;
    }
    nav.addEventListener('click', event => event.stopPropagation());
    nav.querySelector('.awzz-photo-prev').onclick = () => swiper.slidePrev();
    nav.querySelector('.awzz-photo-next').onclick = () => swiper.slideNext();
    mode.onclick = () => setMode(!container.hasAttribute('data-awzz-interacting'));
    swiper.on('slideChange', update);
    container.append(nav);
    update();
  }
  const pending = new WeakMap();
  function enhance(frame) {
    if (frame.dataset.awzz3dSource === frame.src) { setupNavigation(frame); return; }
    if (frame.dataset.awzz3dSource) {
      pending.get(frame)?.disconnect();
      frame.removeAttribute('srcdoc');
      delete frame.dataset.awzz3dSource;
    }
    let url;
    try { url = new URL(frame.src); } catch { return; }
    if (url.hostname !== 'pwzcdn.com' || !url.pathname.includes('/model-viewer/')) return;
    const source = url.searchParams.get('src');
    if (!source || !new URL(source, location.href).pathname.endsWith('/' + modelName)) return;
    frame.dataset.awzz3dSource = frame.src;
    frame.title = 'Interactive AWZZ wheel: drag to rotate and zoom';
    frame.allowFullscreen = true;
    frame.addEventListener('load', () => {
      // The gallery can finish its original iframe navigation after our enhancement.
      if (frame.srcdoc && !frame.contentDocument?.getElementById('wheel')) {
        frame.srcdoc = frame.srcdoc;
        return;
      }
      setupNavigation(frame);
      frame.contentWindow.postMessage({type:'awzz-3d-interaction',active:frame.closest('.pwzrswiper-container')?.hasAttribute('data-awzz-interacting') || false}, location.origin);
    });
    setupNavigation(frame);
    const visible = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      visible.disconnect();
      frame.srcdoc = `<!doctype html><html lang="en"><head><meta name="viewport" content="width=device-width,initial-scale=1"><style>
        *{box-sizing:border-box}html,body{margin:0;width:100%;height:100%;background:#fff;font-family:Arial,sans-serif;color:#222}
        model-viewer{width:100%;height:100%;--progress-bar-color:#222;touch-action:pan-y}
        .hint{position:absolute;bottom:20px;left:16px;right:68px;pointer-events:none;font-size:12px;line-height:1.5;letter-spacing:.02em;text-shadow:0 0 5px #fff,0 0 5px #fff}
        .hint strong{display:block;font-size:11px;letter-spacing:.14em;text-transform:uppercase}.touch{display:none}
        .controls{position:absolute;right:14px;bottom:18px;display:grid;box-shadow:0 0 0 1px #ddd;background:#fff}
        button{border:0;background:#fff;color:#333;width:40px;height:40px;font-size:23px;cursor:pointer}button:focus-visible{outline:2px solid #222;outline-offset:-3px}
        .motion{position:absolute;top:14px;right:14px;width:auto;padding:0 12px;height:32px;font-size:11px;border:1px solid #ddd;border-radius:3px}
        @media(pointer:coarse){.touch{display:inline}.mouse{display:none}.hint{bottom:16px;font-size:11px}.controls{bottom:68px}.hint,.motion{display:none}.awzz-active .hint{display:block;bottom:68px;right:68px}.awzz-active .motion{display:block}.controls{display:none}.awzz-active .controls{display:grid}}
      </style></head><body>
      <model-viewer id="wheel" src="${escape(source)}" alt="AWZZ 18x8.5 Gloss Black interactive wheel" camera-controls aria-describedby="hint" camera-orbit="-30deg 78deg auto" field-of-view="33deg" min-field-of-view="12deg" max-field-of-view="45deg" auto-rotate auto-rotate-delay="0" rotation-per-second="6deg" interaction-prompt="none" environment-image="neutral" exposure="1" shadow-intensity="0.6" shadow-softness="0.8" ar ar-modes="webxr scene-viewer quick-look"></model-viewer>
      <div class="hint" id="hint"><strong>Explore in 3D</strong><span class="mouse">Drag to rotate · Scroll to zoom</span><span class="touch">Drag to rotate · Pinch to zoom</span></div>
      <button class="motion" id="motion" aria-pressed="false">Pause rotation</button>
      <div class="controls"><button id="in" aria-label="Zoom in">+</button><button id="out" aria-label="Zoom out">−</button><button id="full" aria-label="Enter fullscreen">⛶</button></div>
      <script type="module" src="${escape(viewerUrl)}"></script>
      <script type="module">
        await customElements.whenDefined('model-viewer');
        const wheel=document.getElementById('wheel'),motion=document.getElementById('motion');
        function toggle(paused){wheel.toggleAttribute('auto-rotate',!paused);motion.setAttribute('aria-pressed',String(paused));motion.textContent=paused?'Resume rotation':'Pause rotation';}
        if(matchMedia('(prefers-reduced-motion: reduce)').matches) toggle(true);
        motion.onclick=()=>toggle(wheel.hasAttribute('auto-rotate'));
        addEventListener('message',event=>{
          if(event.source!==parent || event.origin!==${JSON.stringify(location.origin)} || event.data?.type!=='awzz-3d-interaction') return;
          document.body.classList.toggle('awzz-active',event.data.active);
          if(event.data.active) toggle(true);
        });
        wheel.addEventListener('pointerdown',()=>toggle(true));
        wheel.addEventListener('wheel',()=>toggle(true),{passive:true});
        for(const [id,factor] of [['in',.8],['out',1.25]]) document.getElementById(id).onclick=()=>{toggle(true);wheel.fieldOfView=Math.max(12,Math.min(45,wheel.getFieldOfView()*factor))+'deg';};
        const full=document.getElementById('full');
        full.hidden=!document.fullscreenEnabled;
        full.onclick=()=>{if(document.fullscreenElement)document.exitFullscreen();else document.documentElement.requestFullscreen();};
        document.addEventListener('fullscreenchange',()=>full.setAttribute('aria-label',document.fullscreenElement?'Exit fullscreen':'Enter fullscreen'));
        wheel.addEventListener('error',()=>{document.querySelector('.hint').textContent='3D view could not load. Please try again.';});
      </script></body></html>`;
    });
    pending.set(frame, visible);
    visible.observe(frame);
  }
  const scan = () => {
    document.querySelectorAll('iframe').forEach(enhance);
    document.querySelectorAll('.rio-media-gallery[data-awzz-gallery]').forEach(gallery => {
      if (!gallery.querySelector('iframe[data-awzz3d-source]')) gallery.removeAttribute('data-awzz-gallery');
    });
  };
  scan();
  new MutationObserver(scan).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['src']});
})();
